export class StringHandler {

	static removeAccents(str:string) {
		return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	}

	static cleanName(str:string) : string {
		let s = str.trim().toLocaleLowerCase();
		let words = s.split(" ");
		for (let f = 0; f < words.length; f++) {
			words[f] = words[f][0].toUpperCase() + words[f].slice(1);
		}
		s = words.join(" ");
		return s;
	}

	static cleanSentence(str:string|null|undefined) : string | null {
		if (!str)
			return null;

		let s = str.trim();
		let sentences = s.split(". ");
		for (let f = 0; f < sentences.length; f++) {
			if (sentences[f][0])
				sentences[f] = sentences[f][0].toLocaleUpperCase() + sentences[f].slice(1);
		}
		s = sentences.join(". ");
		return s;
	}

    static cleanAllCaps(str:string) : string {
        return str.trim().toLocaleUpperCase();
    }
}